<template>
  <van-overlay :show="loading">
    <div class="wrapper"
         @click.stop>
      <div class="block flex_center_center">
        <van-loading color="#1ac388" />
      </div>
    </div>
    <slot></slot>
  </van-overlay>

</template>

<script>
export default {
  props: {
    loading: false
  }
}
</script>

<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.van-overlay {
  z-index: 10;
}
.block {
  width: 120px;
  height: 120px;
}
</style>